// extracted by mini-css-extract-plugin
module.exports = {"container":"ResumeWrapper_container__cRrq5","page-footer":"ResumeWrapper_page-footer__I9KTu"};